module.exports = __webpack_public_path__ + "img/Feature.a0a8f5fd.jpg";